module.exports = __webpack_public_path__ + "img/emoji_81.7b4db57c.png";